// extracted by mini-css-extract-plugin
export default {"popover-menu":"Menu_popover-menu__xZnNE"};